import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    requiredNumber,
    requiredUuid,
} from './fields';
import { SYNC_UPDATE_VALIDATION_SCHEMA } from './common';

export const createEventHorsesAddSchema = () =>
    z.object({
        id: requiredUuid(),
        created_at: requiredNumber(),
        updated_at: requiredNumber(),
        event_id: requiredUuid(),
        horse_id: requiredUuid(),
        user_id: requiredUuid(),
        organisation_id: requiredUuid(),
    });

export const createEventHorsesUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createEventHorsesAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.event_horses,
    );

export const createEventHorsesDeleteSchema = () => createDeleteSchema();

export const createEventHorsesSchemas = () => ({
    add: createEventHorsesAddSchema(),
    update: createEventHorsesUpdateSchema(),
    delete: createEventHorsesDeleteSchema(),
});
